import React from 'react'
import L from 'leaflet'
import { withMap } from './MapContext'

class Circle extends React.Component {
  componentDidMount() {
    this.circle = L.circle(this.props.position, this.props.options)

    // L.circle([51.508, -0.11], 500, {
    // color: 'red',
    // fillColor: '#f03',
    // fillOpacity: 0.5
    // }).addTo(mymap).bindPopup("I am a circle.");

    // this.imageLayer = L.imageOverlay(this.props.url, this.props.bounds)
    this.layers = L.layerGroup([this.circle]).addTo(this.props.map)

    if(this.props.onClick) {
      this.circle.on('click', this.props.onClick)
    }
  }

  componentWillUnmount() {
    // this.leafletElement.off('move', this.onViewportChange)
    // this.leafletElement.off('moveend', this.onViewportChanged)
    if(this.props.onClick) {
      this.circle.off('click', this.props.onClick)
    }

    this.layers.removeLayer(this.circle)
  }

  render() {
    return null
  }
}

export default withMap(Circle)



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/components/Circle.js